import iLoadingSpinner from "../../../assets/icons/loading-spinner.svg";
import "./loading.sass";

type Props = {
  isLoading: boolean;
  width?: number;
  height?: number;
};

const Loading = ({ isLoading, width = 100, height = 100 }: Props) => {
  if (!isLoading) {
    return null;
  }

  return (
    <div
      className="loading"
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <img src={iLoadingSpinner} alt="loading" />
    </div>
  );
};

export default Loading;
